import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = [
  { value: "sedentary", labelKey: "sedentary", descKey: "sedentaryDesc" },
  {
    value: "lightly_active",
    labelKey: "lightlyActive",
    descKey: "lightlyActiveDesc",
  },
  {
    value: "moderately_active",
    labelKey: "moderatelyActive",
    descKey: "moderatelyActiveDesc",
  },
  { value: "very_active", labelKey: "veryActive", descKey: "veryActiveDesc" },
  {
    value: "super_active",
    labelKey: "superActive",
    descKey: "extraActiveDesc",
  },
] as const

export default function ActivityLevel() {
  return <SingleSelectPage translationKey="activityLevel" options={OPTIONS} />
}
